import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Assuming you might link to a store page
import { API_BASE_URL } from '../config/api';

export default function FeaturedSupermarkets() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchFeaturedStores = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await fetch(`${API_BASE_URL}/stores/featured?limit=5`); // Fetch 5 stores
        const data = await response.json();
        if (response.ok) {
          // API might return data directly as an array or nested under a 'data' key
          setStores(Array.isArray(data) ? data : data.data || []);
        } else {
          setError(data.message || 'Failed to fetch featured supermarkets.');
        }
      } catch (err) {
        console.error('Fetch featured stores error:', err);
        setError('An error occurred while fetching featured supermarkets.');
      }
      setLoading(false);
    };

    fetchFeaturedStores();
  }, []);

  if (loading) {
    return (
      <section className="max-w-5xl mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold mb-8 text-gray-800 text-center">Featured Stores</h2>
        <div className="text-center py-6">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-400 mx-auto"></div>
          <p className="text-gray-500 mt-2 text-sm">Loading...</p>
        </div>
      </section>
    );
  }

  if (error) {
    console.error("FeaturedSupermarkets Error:", error);
    return null; // Or a very subtle error message if preferred
  }

  if (stores.length === 0) {
    return null; // Don't render the section if there's nothing to show or an error occurred.
  }

  return (
    <section className="max-w-5xl mx-auto px-4 py-12">
      <h2 className="text-3xl font-bold mb-8 text-gray-800 text-center">Featured Stores</h2>
      <div className="flex flex-wrap justify-center gap-x-8 gap-y-6 items-center">
        {stores.map((store) => (
          // Assuming store object has id, name, slug, logo_url, city
          // Replace `/store/${store.slug || store.id}` with actual link to store page if you have one
          <Link 
            key={store.id} 
            to={`/stores/${store.slug || store.id}`} // Example link, adjust as needed
            className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg transition duration-150 ease-in-out min-w-[120px] text-center"
          >
            <img 
              src={store.logo_url || '/placeholder-product.svg'} 
              alt={`${store.name} logo`}
              className="h-12 object-contain mb-2 transition-transform duration-200 ease-in-out group-hover:scale-105"
              style={{maxHeight: '48px'}} // Ensure logos are not excessively large
            />
            <span className="text-gray-700 text-sm font-semibold group-hover:text-red-800">{store.name}</span>
            {store.branches && store.branches.length > 1 ? (
              <span className="text-gray-500 text-xs">{store.branches.length} locations</span>
            ) : (
              store.city && <span className="text-gray-500 text-xs">{store.city}</span>
            )}
          </Link>
        ))}
      </div>
    </section>
  );
} 